import React from "react";
import { observer } from "mobx-react";
import { Message } from "semantic-ui-react";
import { withTranslation } from "react-i18next";

const NoCreditCardSelectedMessage = observer(({ t }) => (
  <Message warning>
    <Message.Header>{t("billingCentral:noCreditCardSelected")}</Message.Header>
    <p>{t("billingCentral:pleaseSelectACreditCard")}</p>
  </Message>
));

export default withTranslation()(NoCreditCardSelectedMessage);
